export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_09-606fda3dd2f19d2912f764557c80bb7f.png";